import { useMutation, useQueryClient } from '@tanstack/vue-query';

import { saveUserSpecialties } from '@/api/specialties';
import { resetSingleFeed } from '@/composables/feed/useSingleFeed';

export function useSaveUserSpecialties({ onSuccess } = {}) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ specialties, subSpecialties }) => {
      return saveUserSpecialties({ specialties, subSpecialties });
    },
    onSuccess(data) {
      resetSingleFeed({ queryClient });

      onSuccess?.(data);
    },
  });

  return { saveUserSpecialties: mutation.mutate, ...mutation };
}
